function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.55,
    y: 15.42,
    width: 49.98,
    height: 58.19,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.36,41.78a4.83,4.83,0,0,1-9.63,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.42,63.49a31.51,31.51,0,0,1-18.88,5.94c-12.09,0-18.87-5.94-18.87-5.94",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.51,56.6a23.3,23.3,0,0,1-14,4.4c-8.94,0-14-4.4-14-4.4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.82,49.48a17.16,17.16,0,0,1-10.28,3.24,16.34,16.34,0,0,1-10.27-3.24",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.52 10.06 24.59 39.23 40.4 39.23 26.59 63.15 56.5 33.45 39.26 33.45 45.52 10.06",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "#fff",
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.52 10.06 24.59 39.22 40.21 39.22 26.59 63.15 56.5 33.48 39.26 33.48 45.52 10.06",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "#fff",
      stroke: "currentColor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUps);
export default __webpack_public_path__ + "static/media/ups.aadec5eb04af0c440e928fc41ef37090.svg";
export { ForwardRef as ReactComponent };